import { Modal } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getGlobal, setGlobal, useGlobal } from 'reactn';
import api from '../../../api';
import HouseWhiteIcon from '../../assets/HouseWhite.png';
import Button from '../../common/button/Button';
import Card from '../../common/card/Card';

const Properties = ({ ...rest }) => {
  const [showModal, setShowModal] = useState(false);
  const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);
  const history = useHistory();
  const { serviceAccounts } = getGlobal();
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const [defaultAccountNumber] = useGlobal('defaultAccountNumber');

  if (!serviceAccounts && !selectedServiceAccountIndex)
    return <h4>ACCOUNT DATA UNAVAILABLE</h4>;

  const selectedAccount = serviceAccounts[selectedServiceAccountIndex];

  const handleRemoveProperty = async () => {
    const res = await api.removeSvcAccount(
      serviceAccounts[selectedServiceAccountIndex].data.ACCOUNT,
        serviceAccounts[selectedServiceAccountIndex].data.CUST_CODE
    );
    setShowRemoveConfirmation(true);

    if (res.error) console.log({ ERROR: res.error });
  };

  const handleConfirmClose = () => {
    setShowRemoveConfirmation(false);
    setShowModal(false);
    window.location.reload();
  };

  return (
    <Card title="Properties" {...rest} style={{ height: '50%' }}>
      <div style={{ height: '850px', overflowY: 'scroll' }}>
        {serviceAccounts.length > 0 ? (
          serviceAccounts.map((serviceAccount, index) => {
            const {
              ACCOUNT,
              CUST_CODE,
              NAME_LINE1,
              SA_STRNUM,
              SA_STRNAME,
              SA_CITY,
              SA_ZIP_CODE,
            } = serviceAccount?.data;

            const selected = selectedServiceAccountIndex === index;
            return (
              <div
                key={`${ACCOUNT}${CUST_CODE}`}
                className={`p-4 ${
                  selectedServiceAccountIndex === index
                    ? 'bg-gray-200'
                    : 'hover:bg-gray-100 cursor-pointer'
                }`}
                onClick={() =>
                  setGlobal({ selectedServiceAccountIndex: index })
                }
              >
                <div className={`text-xl font-medium `}>{`Property ${
                  index + 1
                } ${selected ? '(Selected)' : ''}`}</div>
                {ACCOUNT === parseInt(defaultAccountNumber, 10) ? (
                  <p className={`font-medium mt-2`}>DEFAULT</p>
                ) : (
                  ''
                )}
                <h3 className={`font-medium mt-2`}>Account Number:</h3>
                <div>{ACCOUNT}</div>
                <h3 className={`font-medium mt-2 `}>Customer Code:</h3>
                <div>{CUST_CODE}</div>
                <h3 className={`font-medium mt-2 `}>Address:</h3>
                <div className={``}>{NAME_LINE1}</div>
                <div className={``}>{`${SA_STRNUM} ${SA_STRNAME}`}</div>
                <div>{`${SA_CITY}, NY`}</div>
                <div>{SA_ZIP_CODE}</div>
                {selected && (
                  <Button
                    className="w-full"
                    // secondary
                    onClick={() => setShowModal(true)}
                  >
                    Remove
                  </Button>
                )}
              </div>
            );
          })
        ) : (
          <div>Your properties will be shown here.</div>
        )}
      </div>
      <Button
        iconUrl={HouseWhiteIcon}
        className="w-full"
        onClick={() => {
          history.push('/user/find-property');
        }}
      >
        Add Property
      </Button>
      <Modal
        open={showModal}
        closable={false}
        footer={null}
        width="25vw"
        onCancel={() => {
          setShowModal(false);
          setShowRemoveConfirmation(false);
        }}
      >
        <div>
          {!showRemoveConfirmation ? (
            <>
              <p className="font-bold text-center pb-2">
                Are you sure you want to remove the following property from your
                profile?
              </p>

              <h3 className={`font-medium mt-2`}>Account Number:</h3>
              <div>{selectedAccount?.data.ACCOUNT}</div>
              <h3 className={`font-medium mt-2 `}>Customer Code:</h3>
              <div>{selectedAccount?.data.CUST_CODE}</div>
              <h3 className={`font-medium mt-2 `}>Address:</h3>
              <div>{selectedAccount?.data.NAME_LINE1}</div>
              <div>{`${selectedAccount?.data.SA_STRNUM} ${selectedAccount?.data.SA_STRNAME}`}</div>
              <div>{`${selectedAccount?.data.SA_CITY}, NY`}</div>
              <div>{selectedAccount?.data.SA_ZIP_CODE}</div>

              <Button className="w-full" onClick={handleRemoveProperty}>
                Yes
              </Button>
            </>
          ) : (
            <div onClick={handleConfirmClose}>
              The selected property has been successfully removed.
              <Button className="w-full" onClick={handleConfirmClose}>
                Close
              </Button>
            </div>
          )}
        </div>
      </Modal>
    </Card>
  );
};

export default Properties;
